<template>
  <v-menu
    v-model="fromDateMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        prepend-icon="mdi-calendar-range"
        v-model="textFieldDate"
        @blur="changedInput"
        v-on="readonly ? {} : on" 
        :readonly="readonly"
        :rules="rules"
        :title="title"
        @click="$emit('click', $event)"
      >
      </v-text-field>
    </template>
    <v-date-picker
      locale="en-gb"
      :value="value"
      no-title
      @input="changed"
      :readonly="readonly"
    ></v-date-picker>
  </v-menu>
</template>
<script>
import Utils from '@/utils.js';

export default {
  inheritAttrs: false,
  props: {
    value: { type: String },
    label: { type: String },
    readonly: { type: Boolean },
    rules: { type: Array },
    title: {type: String, default: ''}
  },

  data: () => ({
    fromDateMenu: false,
    textFieldDate: null,
  }),
  watch: {
    value(newVal) {
      this.textFieldDate = this.formatDate(newVal);
    },
  },
  mounted() {
    //if (this.value) this.textFieldDate = this.formatDate(this.value);
    this.textFieldDate = this.formatDate(this.value);
  },
  methods: {
    changed(value) {
      this.fromDateMenu = false;
      this.$emit('input', value);
    },
    changedInput() {
      if (!this.textFieldDate) return;
      const [day, month, year] = this.textFieldDate.split('/');
      const value = `${year}-${month}-${day}`;
      this.$emit('input', value);
    },
    formatDate(date) {
      if (!date) return null;
      const invalidDates = ['0001-01-01', '01/01/1', '0001-01-01T00:00:00', '1/1/0001'];
      if (invalidDates.includes(date)) {
        return null;
      }

      let d = null;
      
      if (date.includes("T")) {
        // ISO-like datetime (e.g., "2024-12-31T00:00:00")
        d = new Date(date);
      } else if (date.includes("-")){
        const parts = date.split("-");
        if (parts.length == 3){
          const [year, month, day] = parts.map(Number);
          d = new Date(year, month - 1, day);
        }
      } else if (date.includes('/')){
        const parts = date.split("/");
        if (parts.length == 3){
          const [year, month, day] = parts.map(Number);
          d = new Date(year, month - 1, day);
        }
      }
      
      //const d = new Date(date);
      if (isNaN(d.getTime())){
        return null;
      }

      const dateStr = Utils.getDateStr(d);
      return dateStr;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input {
  margin-top: 0px;
  padding-top: 10px;
  max-width: 420px;
}
</style>
